import { render, staticRenderFns } from "./BdProfile.vue?vue&type=template&id=84fdefa2&scoped=true&"
import script from "./BdProfile.vue?vue&type=script&lang=js&"
export * from "./BdProfile.vue?vue&type=script&lang=js&"
import style0 from "./BdProfile.vue?vue&type=style&index=0&id=84fdefa2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84fdefa2",
  null
  
)

export default component.exports